
export enum WidgetTypeEnum {
  Text = 'text',
  Button = 'button',
  DropdownCalculator = 'dropdownCalculator',
  TwoFieldsCalculator = 'twoFieldsCalculator'
}


export enum PaymentWidgetEnum {
  SANTANDER_INSTALLMENT_AT = 'santander_installment_at',
  SANTANDER_INSTALLMENT = 'santander_installment',
  SANTANDER_FACTORING_DE = 'santander_factoring_de',
  SANTANDER_INSTALLMENT_DK = 'santander_installment_dk',
  SANTANDER_INSTALLMENT_NL = 'santander_installment_nl',
  SANTANDER_INSTALLMENT_NO = 'santander_installment_no',
  SANTANDER_INSTALLMENT_SE = 'santander_installment_se',
  IVY = 'ivy',
  GOOGLE_PAY = 'google_pay',
  APPLE_PAY = 'apple_pay',
  ZINIA_INSTALLMENT = 'zinia_installment',
  ZINIA_INSTALLMENT_DE = 'zinia_installment_de',
  ZINIA_LENDING_DE = 'zinia_lending_de',
  PAYPAL = 'paypal',
  PAYBACK = 'payback',
  RESURS_INSTALLMENT = 'resurs_installment',
}
